module.exports = __webpack_public_path__ + "static/media/soono-business.a326f9e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/soono-business.png
// module id = 1182
// module chunks = 0